export default __webpack_public_path__ + "static/media/290.7ea42aa2.jpg";